var _classCallCheck = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/2/Terralego/Customers/aguram-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/2/Terralego/Customers/aguram-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/2/Terralego/Customers/aguram-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/2/Terralego/Customers/aguram-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/2/Terralego/Customers/aguram-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/2/Terralego/Customers/aguram-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports", "@babel/runtime/helpers/extends", "@babel/runtime/helpers/objectWithoutProperties", "@babel/runtime/helpers/defineProperty", "prop-types", "query-string", "react"], b);else if ("undefined" != typeof exports) b(exports, require("@babel/runtime/helpers/extends"), require("@babel/runtime/helpers/objectWithoutProperties"), require("@babel/runtime/helpers/defineProperty"), require("prop-types"), require("query-string"), require("react"));else {
    var c = {
      exports: {}
    };
    b(c.exports, a._extends, a.objectWithoutProperties, a.defineProperty, a.propTypes, a.queryString, a.react), a.withHashState = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a, b, c, d, e, f, g) {
  "use strict";

  var h = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = a.withHashState = a.DEFAULT_OPTIONS = void 0, b = h(b), c = h(c), d = h(d), e = h(e), g = h(g);
  /**
  * Default options for reading and writing from hash.
  */

  var i = {
    encode: !1,
    arrayFormat: "comma",
    sort: !1,
    parseNumbers: !0,
    parseBooleans: !0
  };
  a.DEFAULT_OPTIONS = i;

  var j = function j() {
    return (0, f.parse)(window.location.hash, i);
  },
      k = function k(a) {
    return "#".concat((0, f.stringify)(a, i));
  },
      l = function l(a) {
    var f =
    /*#__PURE__*/
    function (_g$default$Component) {
      _inherits(f, _g$default$Component);

      function f() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, f);

        for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
          a[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(f)).call.apply(_getPrototypeOf2, [this].concat(a))), (0, d.default)(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
          initialState: j() // To keep compatibility

        }), (0, d.default)(_assertThisInitialized(_assertThisInitialized(_this)), "getCurrentHashString", k), (0, d.default)(_assertThisInitialized(_assertThisInitialized(_this)), "onHashChange", function () {
          _this.isUnmount || _this.setState({
            initialState: j()
          });
        }), (0, d.default)(_assertThisInitialized(_assertThisInitialized(_this)), "updateHashString", function (a) {
          var b = _this.props.updateHash;
          b && window.history.replaceState(window.history.state, "", k(a));
        });
        return _this;
      }

      _createClass(f, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var a = this.props.listenHash;
          a && window.addEventListener("hashchange", this.onHashChange, !1);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.isUnmount = !0, window.removeEventListener("hashchange", this.onHashChange, !1);
        }
        /**
        * Event listener on hash change, reloads the current state from hash
        */

      }, {
        key: "render",
        value: function render() {
          var d = this.props,
              e = d.listenHash,
              f = d.updateHash,
              h = (0, c.default)(d, ["listenHash", "updateHash"]),
              i = this.state.initialState;
          return g.default.createElement(a, (0, b.default)({
            initialState: i
          }, h, {
            getCurrentHashString: k,
            onStateChange: this.updateHashString
          }));
        }
      }]);

      return f;
    }(g.default.Component);

    (0, d.default)(f, "propTypes", {
      /** @param {boolean} [listenHash=true] If initialState should be update when hash changes */
      listenHash: e.default.bool,

      /** @param {boolean} [updateHash=true] If hash should be updated when initialState changes */
      updateHash: e.default.bool
    }), (0, d.default)(f, "defaultProps", {
      listenHash: !0,
      updateHash: !0
    });
    var h = a.displayName || a.name;
    return f.displayName = "withHashState(".concat(h, ")"), f;
  };

  a.withHashState = l;
  a.default = l;
});